import { AnimatePresence } from 'motion/react';
import styled from 'styled-components';

import { Toast } from './Toast';
import { useToast } from '../../../hooks/useToast';
import { media } from '../../../media';

const Root = styled.div`
  position: fixed;
  top: 24px;
  right: 24px;
  left: 24px;
  z-index: 10;
  display: flex;
  flex-direction: column;
  gap: 8px;

  @media ${media.sm} {
    top: 24px;
    bottom: auto;
    right: 32px;
    left: auto;
    gap: 12px;
  }
`;

export const Toasts = () => {
  const { toasts } = useToast();

  return (
    <Root>
      <AnimatePresence>
        {toasts.map((toast) => (
          <Toast key={toast.id} {...toast} />
        ))}
      </AnimatePresence>
    </Root>
  );
};
